import { ToasterIdEnum } from "@/enums";
import type { ToasterId } from "@/types";

export const DEFAULT_TOASTER_ID: ToasterId = ToasterIdEnum.SYSTEM;
export const DEFAULT_TOASTER_PRIORITY: ToasterId[] = [
  ToasterIdEnum.FORM,
  ToasterIdEnum.SYSTEM,
];
export const DEFAULT_TOAST_DURATION = 5000;
export const DEFAULT_VISIBLE_TOASTS = 5;
